import React from 'react';
import { StyledCheckboxLabel, StyledCheckboxHiddenInput, StyledCheckbox, StyledCheckboxIcon } from './Checkbox.styles.mjs';

const Checkbox = (props) => {
    return (React.createElement(StyledCheckboxLabel, null,
        React.createElement(StyledCheckboxHiddenInput, Object.assign({}, props)),
        React.createElement(StyledCheckbox, null,
            React.createElement(StyledCheckboxIcon, null))));
};

export { Checkbox as default };
//# sourceMappingURL=Checkbox.mjs.map
